import axios from 'axios';

export const request = axios.create({
  baseURL: 'https://www.lista.ba:8443',
  withCredentials: true,
  credentials: 'same-origin',
  timeout: 1000 * 60 * 3,
});
